import { useGlobalState } from 'contexts/GlobalStateContext'
import MyRewards from 'pages/MyRewards'
import IncentiveDashboard from 'pages/IncentiveDashboard'
import React from 'react'

const Dashboard: React.FC = () => {
  const { checkSubscriptionTierFeature } = useGlobalState()

  // Show incentive dashboard if org has INCENTIVE feature, otherwise show rewards
  return checkSubscriptionTierFeature('INCENTIVE.ALL') ? <IncentiveDashboard /> : <MyRewards />
}

export default Dashboard
